module.exports = __webpack_public_path__ + "img/settings.a883954e.svg";